export const SERVER = "https://eduzy2025-server.onrender.com";
// export const SERVER = "http://localhost:8080";
